/**
 * @generated SignedSource<<625cb703df7c645bf7e3ec3aaecccfcc>>
 * @relayHash fe8226dd520c633c0bf22376318fa2b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 054695c660b333aa47f394d904493232dfdc2ef042f8bf5b0494439fafa74ec1

import type { ConcreteRequest } from 'relay-runtime';
export type useCommsFeaturesQuery$variables = {
  cloudId?: string | null;
};
export type useCommsFeaturesQuery$data = {
  readonly stakeholderComms_getStakeholderCommsTransformerRecord: {
    readonly transformerRecord: {
      readonly jsmProductDetail: {
        readonly license: string | null;
      } | null;
    } | null;
  } | null;
};
export type useCommsFeaturesQuery = {
  response: useCommsFeaturesQuery$data;
  variables: useCommsFeaturesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "StakeholderCommsTransformerRecordResponse",
    "kind": "LinkedField",
    "name": "stakeholderComms_getStakeholderCommsTransformerRecord",
    "plural": false,
    "selections": [
      {
        "concreteType": "StakeholderCommsTransformerRecord",
        "kind": "LinkedField",
        "name": "transformerRecord",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsJsmProductDetail",
            "kind": "LinkedField",
            "name": "jsmProductDetail",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "license"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommsFeaturesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommsFeaturesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "054695c660b333aa47f394d904493232dfdc2ef042f8bf5b0494439fafa74ec1",
    "metadata": {},
    "name": "useCommsFeaturesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0640218939a9c850a22d200c8feade76";

export default node;
